import { useEffect, useContext, useMemo, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { TrainingLedger, TrainingLedgerSearchForm } from 'entities/training_ledger'

import { A4 } from 'components/shared/print'
import { Flex } from 'components/shared/flex'
import { Button } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { EditTrainingLedgerForm } from './training_ledger_form'

import { useFetchTrainingLedgerApi } from 'api/training_ledger'
import { CustomTd } from 'components/shared/widget'

type Props = {
    history: H.History
}

export const TrainingLedgerPaperPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const [showEdit, setShowEdit] = useState(false)
    const [trainingLedger, setTrainingLedger] = useState<TrainingLedger>({})
    const query = useQuery<TrainingLedgerSearchForm>()
    const searchForm = useForm<TrainingLedgerSearchForm>({ ...query})
    const listApi = useFetchTrainingLedgerApi(searchForm)

    useEffect(() => {
        searchForm.set(query)
    }, [query.id])

    useEffectSkipFirst(() => {
        globalState.setLoading(listApi.loading)
        if (listApi.isSuccess() && listApi.response.results.length == 1) {
            setTrainingLedger(listApi.response.results[0])
        }
    }, [listApi.loading])
    return (
        <>
            <ContentHeader
                className="no-print"
                headerTitle="教育研修・技能評価記録台帳"
                right={
                    <>
                        <Button
                            onClick={() => {
                                window.print()
                            }}
                        >
                            印刷プレビュー
                        </Button>
                        {listApi.response.results.length == 1 && (
                            <Button variant="success" onClick={() => setShowEdit(true)}>
                                 編集
                            </Button>
                        )}
                        <Button variant="secondary" onClick={() => props.history.push(`/ledger/training`)}>
                            測定作業日誌一覧へ戻る
                        </Button>
                    </>
                }
            />
            <EditTrainingLedgerForm
                show={showEdit}
                trainingLedger={trainingLedger}
                // setTrainingLedger={setTrainingLedger}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    setShowEdit(false)
                }}
            />
            {listApi.response.results.map((m) => (
                <TrainingLedgerPaper trainingLedger={listApi.response.results.length === 1 ? trainingLedger : m} key={m.id} />
            ))}
        </>
    )
}

export default withRouter(TrainingLedgerPaperPage)

type TrainingLedgerPaperProps = {
    trainingLedger?: TrainingLedger
}

const TrainingLedgerPaper = (props: TrainingLedgerPaperProps) => {
    const trainingItemCount = 11
    const accessmentItemCount = 7
    const types: Record<string, number> = { training: trainingItemCount, accessment: accessmentItemCount }

    const page = useMemo(() => {
        return Math.max(
            ...Object.keys(types).map((rt) => {
                return Math.ceil(Math.max((props.trainingLedger?.trainingContentSet?.filter((tc) => tc.recordType === rt)?.length ?? 0) / types[rt], 1))
            })
        )
    }, [props.trainingLedger])

    return (
        <>
            {props.trainingLedger?.year &&
                new Array(page).fill(0).map((_, pageIdx) => (
                    <A4 key={'key'} padding={0} landscape={false} style={{ padding: 0 }}>
                        <div className={'preview-result'} style={{ padding: 20 }}>
                            <Flex justifyContent="space-between" style={{ marginBottom: 5, paddingBottom: 20 }}>
                                <div style={{ fontSize: 10 }}>
                                    <div>Form10.01 教育研修・技能評価記録台帳</div>
                                    <div>ver1: 2021/10/20</div>
                                </div>
                                <div style={{ textAlign: 'right', fontSize: 10 }}>{`Page: ${1 + pageIdx} / ${page}`}</div>
                            </Flex>
                            <div style={{ fontWeight: 'bold', fontSize: 30, textAlign: 'center', marginBottom: 20 }}>教育研修・技能評価記録台帳</div>

                            <div style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 30 }}>
                                {`${props.trainingLedger?.year}年度 / 氏名: ${props.trainingLedger?.user?.fullName}`}
                            </div>
                            <div style={{ fontSize: 14 }}>
                                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                    <tr>
                                        <th style={{ padding: 3, fontSize: 16, textAlign: 'left' }} colSpan={2}>
                                            [教育研修記録]
                                        </th>
                                    </tr>
                                    <tbody style={{ border: 'solid 2px' }}>
                                        <tr>
                                            <th style={{ border: 'solid 1px', padding: 3, textAlign: 'center', width: 100 }}>実施日</th>
                                            <th style={{ border: 'solid 1px', padding: 3, textAlign: 'center', width: 300 }}>研修内容</th>
                                            <th style={{ border: 'solid 1px', padding: 3, textAlign: 'center' }} colSpan={2}>
                                                備考
                                            </th>
                                        </tr>
                                        {new Array(trainingItemCount).fill(0).map((_, itemIdx) => {
                                            const content = props.trainingLedger?.trainingContentSet?.filter((t) => t.recordType === 'training')[
                                                trainingItemCount * pageIdx + itemIdx
                                            ]
                                            return (
                                                <tr key={'training-' + itemIdx} style={{ height: 40 }}>
                                                    <CustomTd style={{ border: 'solid 1px', paddingLeft: 3, textAlign: 'center' }}>{content?.date}</CustomTd>
                                                    <CustomTd style={{ border: 'solid 1px', paddingLeft: 3, textAlign: 'left' }}>{content?.content}</CustomTd>
                                                    <CustomTd style={{ border: 'solid 1px', paddingLeft: 3, textAlign: 'left' }} colSpan={2}>
                                                        {content?.memo}
                                                    </CustomTd>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tr style={{ height: 20 }}></tr>
                                    <tr>
                                        <th style={{ padding: 3, fontSize: 16, textAlign: 'left' }} colSpan={2}>
                                            [技能評価記録]
                                        </th>
                                    </tr>
                                    <tbody style={{ border: 'solid 2px' }}>
                                        <tr>
                                            <th style={{ border: 'solid 1px', padding: 3, textAlign: 'center' }}>実施日</th>
                                            <th style={{ border: 'solid 1px', padding: 3, textAlign: 'center' }}>技能評価内容</th>
                                            <th style={{ border: 'solid 1px', padding: 3, textAlign: 'center', width: 80 }}>評価</th>
                                            <th style={{ border: 'solid 1px', padding: 3, textAlign: 'center' }}>備考</th>
                                        </tr>
                                        {new Array(accessmentItemCount).fill(0).map((_, itemIdx) => {
                                            const content = props.trainingLedger?.trainingContentSet?.filter((t) => t.recordType === 'accessment')[
                                                accessmentItemCount * pageIdx + itemIdx
                                            ]
                                            return (
                                                <tr key={'accessment-' + itemIdx} style={{ height: 40 }}>
                                                    <CustomTd style={{ border: 'solid 1px', paddingLeft: 3, textAlign: 'center' }}>{content?.date}</CustomTd>
                                                    <CustomTd style={{ border: 'solid 1px', paddingLeft: 3, textAlign: 'left' }}>{content?.content}</CustomTd>
                                                    <CustomTd style={{ border: 'solid 1px', paddingLeft: 3, textAlign: 'left' }}>{content?.grade}</CustomTd>
                                                    <CustomTd style={{ border: 'solid 1px', paddingLeft: 3, textAlign: 'left' }}>{content?.memo}</CustomTd>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </A4>
                ))}
        </>
    )
}
